//LOGIN FARME
export const POST_FAKE_JWT_LOGIN = "/auth/token";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const POST_FAKE_JWT_REFRESH = "/auth/refresh";
export const POST_FAKE_JWT_REFRESH_TOKEN = "/auth/refresh";
export const POST_FAKE_JWT_LOGOUT = "/auth/logout";
//LABORATORIOS FARME
export const BASE_LABORATORIOS = "/laboratorios";
//USUARIOS FARME
export const BASE_USUARIOS = "/usuarios";
//PRINCIPIOS ACTIVOS FARME
export const BASE_PRINCIPIOSACTIVOS = "/principiosactivos";
//PRINCIPIOS ACTIVOS CATEGORIAS FARME
export const BASE_PRINCIPIOSACTIVOSCATEGORIAS = "/principiosactivocategorizacion";
//Servicio De Entrega
export const BASE_SERVICIODEENTREGAS = "/servicioentregas";
//Planilla Estrategica
export const BASE_PLANILLAESTRATEGICA = "/planillaestrategica";
//Solicitudes
export const BASE_SOLICITUDES = "/solicitud";
//DIAGNOSTICOS FARME
export const BASE_DIAGNOSTICOS = "/diagnostico/";
//PLANTILLAS MENSAJES
export const BASE_PLANTILLASMENSAJES = "/plantillasmensajes/";
//FARMACIAS FARME
export const BASE_FARMACIAS = "/farmacias/";
//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/user";
//SICOTEL
export const BASE_SICOTEL = "/api/v1/siscotel/";
//RUTAS
export const BASE_RUTAS = "/rutas/";
//FACTURAS IA
export const BASE_FACTURAS_IA = "/api/v1/facturas-ia/";
//REPORTES
export const REPORTES_SISCOTEL_PENDIENTES = "/api/v1/reportes/siscotel-pendientes";
//SISCOTEL
export const SISCOTEL_REENVIAR_NOTIFICACION = "/api/v1/siscotel/reenviar-notificacion";
//PLANTAS
export const BASE_PLANTAS = "/api/v1/plantas/";
export const REPORTES_ENTREGAS_PLANTAS = "/api/v1/reportes/entregas-plantas";
export const REPORTES_ENTREGAS_PLANTAS_RESUMEN = "/api/v1/reportes/entregas-plantas/resumen";
//TASA DOLAR
export const BASE_TASA_DOLAR = "/tasadolar/tasa-dolar";
//MERCANTIL SCRAPING
export const MERCANTIL_SCRAPING_RUN = "/api/v1/mercantil/scraping/run";
export const MERCANTIL_SCRAPING_RUNS = "/api/v1/mercantil/scraping/runs";
export const MERCANTIL_SCRAPING_STATUS = "/api/v1/mercantil/scraping/status";
export const MERCANTIL_BUSCAR_REGISTRAR = "/api/v1/mercantil/scraping/buscar-y-registrar";
export const MERCANTIL_SCRAPING_RETRY = "/api/v1/mercantil/scraping/retry";